import React from 'react'
import { makeStyles } from 'tss-react/mui'
import FacetSelections from './FacetSelections'
import { useSearchContext } from './SearchContext'
import Facets from './Facets'

const useStyles = makeStyles()((theme) => ({
  hideOnMobile: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  searchFacets: {
    margin: 0,
  },
  searchFacetsInner: {
    height: `calc(100% - ${theme.spacing(5)})`,
  },
}))

const SearchFacets: React.FC = () => {
  const { classes, cx } = useStyles()
  const { facets, loading, isStructureSearch } = useSearchContext()

  return (
    <div className={cx(classes.hideOnMobile, classes.searchFacets)}>
      <div className={classes.searchFacetsInner}>
        <FacetSelections
          facets={facets}
          isStructureSearch={isStructureSearch}
        />
        <Facets loading={loading} facets={facets} />
      </div>
    </div>
  )
}

export default SearchFacets
